module.exports = __webpack_public_path__ + "img/login-comite15denoviembre.01aae573.svg";